import { render } from "./common-label-container.vue?vue&type=template&id=2c4750ca&scoped=true"
import script from "./common-label-container.vue?vue&type=script&lang=js"
export * from "./common-label-container.vue?vue&type=script&lang=js"

import "./common-label-container.vue?vue&type=style&index=0&id=2c4750ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4750ca"],['__file',"src/components/common/common-label-container.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c4750ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c4750ca', __exports__)) {
    api.reload('2c4750ca', __exports__)
  }
  
  module.hot.accept("./common-label-container.vue?vue&type=template&id=2c4750ca&scoped=true", () => {
    api.rerender('2c4750ca', render)
  })

}


export default __exports__